// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
} from '@mui/material'
import { format } from 'date-fns'
import { useAuth } from '../hooks/useAuth'
import { loadFkspDeletedRequests } from '../lib/apiPhpAdapter'
import { fkspStatusChipColor, fkspStatusLabelCs } from '../lib/fkspStatusLabels'
import type { FkspRequest } from '../types'

export const FkspDeletedView: React.FC = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const isItAdmin = user?.role === 'admin' && user?.admin_type === 'spravce_it'
  const [requests, setRequests] = useState<FkspRequest[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!isItAdmin) return
    setLoading(true)
    loadFkspDeletedRequests()
      .then(setRequests)
      .catch(() => setRequests([]))
      .finally(() => setLoading(false))
  }, [isItAdmin])

  if (!isItAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">Přístup pouze pro správce IT.</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1200, mx: 'auto' }}>
      <button
        type="button"
        className="back-button"
        onClick={() => navigate('/fksp/select-role')}
        style={{ marginBottom: '1rem' }}
      >
        ← Zpět
      </button>

      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
        FKSP — smazané žádosti
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Archiv soft-smazaných žádostek. Viditelné pouze správci IT.
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
          <Table size="small">
            <TableHead sx={{ bgcolor: 'grey.100' }}>
              <TableRow>
                <TableCell>Smazáno</TableCell>
                <TableCell>Žadatel</TableCell>
                <TableCell>Podal(a)</TableCell>
                <TableCell>Typ</TableCell>
                <TableCell align="right">Částka</TableCell>
                <TableCell>Stav</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                    Žádné smazané žádosti
                  </TableCell>
                </TableRow>
              ) : (
                requests.map((req) => (
                  <TableRow key={req.id} hover>
                    <TableCell>
                      {req.deleted_at
                        ? format(new Date(req.deleted_at), 'dd.MM.yyyy HH:mm')
                        : '—'}
                    </TableCell>
                    <TableCell>{req.requester_name}</TableCell>
                    <TableCell>
                      {req.created_by_name && req.created_by_id !== req.requester_id
                        ? req.created_by_name
                        : '—'}
                    </TableCell>
                    <TableCell>{req.type === 'benefity' ? 'Benefity' : 'Připojištění'}</TableCell>
                    <TableCell align="right">
                      {req.type === 'benefity' ? req.amount : req.fksp_contribution} Kč
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={fkspStatusLabelCs(req.status)}
                        color={fkspStatusChipColor(req.status)}
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
